<app-about-us class="card-wide" ></app-about-us>

<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      @switch (_mfaMode) {
        @case (mfaMode.Login) {
          Two Factor Authentication
        }
        @case (mfaMode.Setup) {
          Two Factor Authentication Setup
        }
        @case (mfaMode.Remove){
          Remove Two Factor Authentication
        }
      }
    </mat-card-title>
      <button mat-stroked-button aria-label="Help button" (click)="help()" class="icon-only">
      <mat-icon>help</mat-icon>
    </button>
  </mat-card-header>

  <mat-card-content class="m-b-1">
    <form [formGroup]="mfaForm">
    <div class="d-flex justify-content-center" [hidden]="!loading">
      <mat-spinner></mat-spinner>
    </div>
 
    <div [hidden]="loading" class="mfa-content-column">
     
        <div class="mfa-form-section m-t-1">
          @switch (_mfaMode) {
            @case (mfaMode.Login) {
              Complete logging in with your authenticator app
            }
            @case (mfaMode.Setup) {
              To help protect your account, please use an authenticator app (such as Google Authenticator) to scan this QR code and set up 2FA.
            }
            @case (mfaMode.Remove){
              You are about to remove Two-Factor Authentication. Do you wish to continue?
            }
          }
        </div>

        @if (totpUri != null) {
        <div class="mfa-form-section">
          <qrcode [qrdata]="totpUri" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
          Or enter the code: {{ totpSecret }}
        </div>
        }
       
        <div class="mfa-form-input-section">
          <mat-form-field>
            <mat-label>Verification Code</mat-label>
            <input matInput maxlength="6" [formControl]="mfaCode" type="text" autocomplete="one-time-code" />
            <mat-hint>Please enter the 6 digit code provided by the authenticator app</mat-hint>
            <mat-error *ngIf="mfaCode.hasError('mfaInvalid')">{{ errorMessage }}</mat-error>
            <mat-error *ngIf="mfaCode.invalid && (mfaCode.dirty || mfaCode.touched) && mfaCode.hasError('required')">Verification Code is required</mat-error>
          </mat-form-field>
        </div>
        
    </div>
    </form>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-button mat-stroked-button (click)="logout()">Cancel</button>
    <button mat-flat-button type="button" [disabled]="mfaCode.invalid && mfaCode.hasError('required')" (click)="completeMfaForm()">
      @switch (_mfaMode) {
        @case (mfaMode.Login) {
          Login
        }
        @case (mfaMode.Setup) {
          Setup MFA
        }
        @case (mfaMode.Remove){
          Remove MFA
        }
      }
    </button>
  </mat-card-actions>
</mat-card>
